import React, { useState } from 'react';
import { Star, Facebook, Instagram, Youtube } from 'lucide-react';
import { ParallaxImage } from '../ui/ParallaxImage';
export function Testimonials() {
  const testimonials = [{
    quote: 'PRT changed my life — the community keeps me coming back every single day.',
    author: 'Mike T.',
    duration: 'Member 2 yrs'
  }, {
    quote: "I've tried every gym in Gilbert. Nothing compares to the culture here.",
    author: 'Sarah R.',
    duration: 'Member 18 mo'
  }, {
    quote: 'Lost 40 lbs and gained a group of real friends.',
    author: 'Carlos M.',
    duration: 'Member 3 yrs'
  }];
  return <section id="results" className="relative py-24 overflow-hidden" data-id="element-132">
      <div className="absolute inset-0 z-0" data-id="element-133">
        <ParallaxImage src="https://images.unsplash.com/photo-1518611012118-696072aa579a?q=80&w=2070&auto=format&fit=crop" alt="Group fitness class training together" className="w-full h-full" data-id="element-134" />
        <div className="absolute inset-0 bg-prt-darker/50" data-id="element-135" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <span className="text-prt-tan font-semibold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-138">
            Community Wins
          </span>
          <h2 className="font-heading text-white text-4xl md:text-6xl" data-id="element-139">
            Real People. Real Results.
          </h2>
        </div>

        <div className="flex overflow-x-auto pb-8 -mx-6 px-6 md:grid md:grid-cols-3 md:overflow-visible md:pb-0 md:mx-0 md:px-0 gap-6 snap-x snap-mandatory hide-scrollbar" data-id="element-140">
          {testimonials.map((t, i) => <div key={i} className="bg-prt-surface p-8 rounded-lg border-l-4 border-prt-blue min-w-[300px] md:min-w-0 snap-center shrink-0 w-[85vw] md:w-auto" data-id="element-141">
              <div className="flex text-prt-blue mb-6" data-id="element-142">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-143" />)}
              </div>
              <p className="text-white text-lg italic mb-6 leading-relaxed" data-id="element-144">
                "{t.quote}"
              </p>
              <div data-id="element-145">
                <div className="text-white font-heading text-xl tracking-wide" data-id="element-146">
                  {t.author}
                </div>
                <div className="text-prt-muted text-sm uppercase tracking-wider" data-id="element-147">
                  {t.duration}
                </div>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center gap-6 mt-16" data-id="element-148">
          <a href="#" className="text-prt-blue hover:text-white transition-colors" data-id="element-149">
            <Facebook size={28} data-id="element-150" />
          </a>
          <a href="#" className="text-prt-blue hover:text-white transition-colors" data-id="element-151">
            <Instagram size={28} data-id="element-152" />
          </a>
          <a href="#" className="text-prt-blue hover:text-white transition-colors" data-id="element-153">
            <Youtube size={28} data-id="element-154" />
          </a>
          <a href="#" className="text-prt-blue hover:text-white transition-colors font-bold text-xl" data-id="element-155">
            Yelp
          </a>
        </div>
      </div>
    </section>;
}